import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Container, Button } from 'reactstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { partial } from '../../util/translation/translation';
import validateWebsiteComponentForm from './validateWebsiteComponentForm';
import renderField from '../../shared/components/custom/Field';

const SectionLabelComponentForm = ({
  component,
  handleSubmit,
  initialize,
  onClose,
}) => {
  const s = partial('shared');

  useEffect(() => {
    initialize({
      title: component?.value || '',
    });
  }, [component]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <Container>
        <Row>
          <Col>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="title"
                  component={renderField}
                  placeholder={s('title')}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Button type="submit" color="primary">
              {component?.id ? s('update') : s('create')}
            </Button>
            {onClose ? (
              <Button type="button" color="secondary" onClick={onClose}>
                {s('close')}
              </Button>
            ) : (
              <Link to="/questionnaires?tab=2">
                {' '}
                <Button type="submit" color="secondary">
                  {s('close')}
                </Button>
              </Link>
            )}
          </Col>
        </Row>
      </Container>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'section_label_component_form',
  validate: validateWebsiteComponentForm,
});

export default reduxF(SectionLabelComponentForm);
